export const auction = {
  name: 'Name',
  startDate: 'Data / Ora',
  status: 'Status',
  statusOpen: 'In curand'
}
